import { ParametrosDeRelatorioDeIrmaos, ParametrosDoRelatorioDeCandidatos, TipoDeOrdenacaoDeEvento } from 'common/types/Relatorio'
import axios from '@/plugins/axios'

const baseURL = process.env.NODE_ENV === 'production'
	? `${process.env.VUE_APP_URL_BASE || 'https://somar-app.web.app'}/api/v1`
	: 'http://localhost:3000/api/v1'

class RelatorioService {

	static readonly route = 'relatorios'

	getRelatorioDeCargos({
		formato,
		...query
	}: ParametrosDeRelatorioDeIrmaos) {
		return axios.getUri({
			params: query,
			url: `${baseURL}/${RelatorioService.route}/relatorio-de-cargos.${formato}`,
		})
	}

	getRelatorioDeEvento(nomeDoArquivo: string, params: { evento: string, ordenacao?: TipoDeOrdenacaoDeEvento }) {
		return axios.getUri({
			params,
			url: `${baseURL}/${RelatorioService.route}/relatorio-de-evento/${nomeDoArquivo}.pdf`,
		})
	}

	getRelatorioDeCandidatos({
		formato,
		...query
	}: ParametrosDoRelatorioDeCandidatos) {
		return axios.getUri({
			params: query,
			url: `${baseURL}/${RelatorioService.route}/relatorio-de-candidatos.${formato}`,
		})
	}

}

export default new RelatorioService()
